import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ isAuthed, redirectTo = '/login', children }) {
  if (!isAuthed) return <Navigate to={redirectTo} replace />;
  return children;
}
